import { TemplateConfig } from '../types';

export const wealthFortuneSpreadConfig: TemplateConfig = {
  id: 'wealth-fortune-spread',
  name: '我的财运如何',
  description: '分析财运现状与可能的变化',
  cardCount: 4,
  
  fieldDefaults: {
    title: '我的财运如何',
    customerQuestion: '分析我的财运情况。',
    cardPlaceholders: [
      '请输入第 1 张牌 最上方的牌',
      '请输入第 2 张牌 最左边的牌',
      '请输入第 3 张牌 最下方的牌',
      '请输入第 4 张牌 最右边的牌'
    ],
    cardInfos: [
      '有大额支出吗',
      '财务状况',
      '未来一个月的财运如何',
      '有意外之财吗'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#fa8c16',
    backgroundColor: '#fff7e6',
    icon: '💰'
  }
};
